module.exports = __webpack_public_path__ + "images/cv_bulk_title_6aa852e5f95b6c8af58054a1c6375e2e.png";